// extracted by mini-css-extract-plugin
module.exports = {"logo-wrapper":"styles_logo-wrapper__35Y8N"};